import React, { cloneElement } from 'react';
import PropTypes from 'prop-types';

import { isEmpty } from 'lodash';
import NameRow from './nameRow/NameRow';
import Nav from '../shared/nav/Nav';
import DeclaredBox from './declaredBox/DeclaredBox';
import Details from './details/Details';
import { getHorseType, hasProgeny } from '../utils/horse';
import MetaData from '../shared/metaData/MetaData';
import BestOdds from '../shared/price/BestOdds';
import bloodstockLogoString from './bloodstockLogoString';
import { sireSubTabs } from '../shared/nav/helpers/tabNames';

export const getTabName = ({ tab, subTab }, { sireStatus, damStatus, weatherbysUid }) => {
    if (subTab) {
        return subTab;
    }

    if (tab) {
        return tab;
    }

    if (!sireStatus && !damStatus) {
        return 'form';
    }

    if (sireStatus && weatherbysUid) {
        return 'weatherbys-overview';
    }

    return 'progeny';
};

class HorsePage extends React.Component {
    constructor(props) {
        super(props);
        this.showMyRatings = this.showMyRatings;
        this.hideMyRatings = this.hideMyRatings;

        this.state = {
            isMyRatingShown: (props.params.subTab === 'my-ratings'),
            isMobile: this.isMobile(),
        };
    }

    componentDidMount() {
        window.addEventListener('resize', this.resize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.resize);
    }

    onSubnavMenuExpand = () => {
        this.setState({
            ...this.state,
            isSubnavMenuExpanded: true,
        });
    }

    checkSireStatus() {
        const isInserted = document.querySelector('.hp-details__pinkToRedLine');
        if (isInserted) return;

        const {
            data: {
                profile: {
                    sireStatus,
                },
            },
        } = this.props;

        if (sireStatus) {
            const logoWrap = document.querySelector('.rn-menuBar__logo__wrp');
            const menuBar = document.querySelector('.rn-menuBar');

            logoWrap.innerHTML = bloodstockLogoString;
            menuBar.style.borderTop = '0';
            menuBar.style.borderLeft = '0';
            menuBar.style.borderRight = '0';
            menuBar.style.borderBottom = '3px solid';
            menuBar.style.borderImageSource = 'linear-gradient(to right, #d674ad, #eb212e)';
            menuBar.style.borderImageSlice = '1';
        }
    }

    isMobile = () => {
        const isMobile = window.innerWidth < 720;
        return isMobile;
    }

    resize= () => {
        const isMobile = this.isMobile();

        this.setState({
            ...this.state,
            isMobile,
        });

        localStorage.setItem('isMobile', `${isMobile}`);

        const screenResizedEvt = new CustomEvent('screen-resized', {
            detail: isMobile,
        });

        window.dispatchEvent(screenResizedEvt);
    }

    showMyRatings = () => {
        this.setState({ isMyRatingShown: true });
    }

    hideMyRatings = () => {
        this.setState({ isMyRatingShown: false });
    }

    render() {
        const { data, children, params, userRole, pageName, hasAccess } = this.props;
        const {
            externalLinks: { helpCenterUrl, imagesUrl },
            profile, entries, quotes,
            skybetDiffusionName,
        } = data;

        this.checkSireStatus();

        const { weatherbysUid, sireStatus, comments, horseName } = profile;
        const { isMobile, isSubnavMenuExpanded } = this.state;
        const tabPage = getTabName(params, profile);
        const tabsToExclude = [
            (!weatherbysUid || !sireStatus) && 'stallionDetails',
            hasProgeny(profile) && isEmpty(entries) && 'entries',
            isEmpty(quotes) && 'quotes',
        ];

        params.mr = {
            show: this.showMyRatings,
            hide: this.hideMyRatings,
            isShown: this.state.isMyRatingShown,
        };

        return (
            <div
                className={
                    weatherbysUid &&
                    sireSubTabs.stallionDetails.includes(tabPage) ? 'weatherbys__wrapper' : ''
                }
            >
                <MetaData
                    type={params.type}
                    page={tabPage}
                    profile={profile}
                />
                <section>
                    <NameRow
                        profile={profile}
                        params={params}
                        imagesHost={imagesUrl}
                        isMobile={isMobile}
                        isWeatherbysSire={!!(sireStatus && weatherbysUid)}
                    />
                    <Details
                        {...profile} isMobile={isMobile}
                    />
                    <DeclaredBox
                        horseName={horseName}
                        entries={entries || []}
                        comments={comments || []}
                    />
                    <BestOdds skybetDiffusionName={skybetDiffusionName} />
                </section>
                <Nav
                    params={params}
                    userRole={userRole}
                    pageName={pageName}
                    horseType={getHorseType(profile)}
                    helpUrl={helpCenterUrl}
                    tabsToExclude={tabsToExclude}
                    isMobile={isMobile}
                    isSubnavMenuExpanded={isSubnavMenuExpanded}
                    onSubnavMenuExpand={this.onSubnavMenuExpand}
                />
                {cloneElement(children, { data, params, isMobile, hasAccess })}
            </div>
        );
    }
}

HorsePage.propTypes = {
    data: PropTypes.shape({
        externalLinks: PropTypes.shape({
            imagesUrl: PropTypes.string.isRequired,
            helpCenterUrl: PropTypes.string.isRequired,
            weatherbysDomain: PropTypes.string.isRequired,
        }).isRequired,
        profile: PropTypes.shape({
            weatherbysUid: PropTypes.string,
        }).isRequired,
    }).isRequired,
    params: PropTypes.shape({
        type: PropTypes.string,
        id: PropTypes.string,
        name: PropTypes.string,
        tab: PropTypes.string,
        hash: PropTypes.string,
        subTab: PropTypes.string,
    }).isRequired,
    hasAccess: PropTypes.bool,
    userRole: PropTypes.string,
    children: PropTypes.node.isRequired,
    pageName: PropTypes.string.isRequired,
};


export default HorsePage;



// WEBPACK FOOTER //
// ./src/js/horse/HorsePage.jsx